package com.milta.feature.subscription.domain.usecase

import com.milta.feature.subscription.domain.entity.Subscription
import com.milta.feature.subscription.domain.repository.SubscriptionRepository

class SubmitReceiptUseCase(private val repository: SubscriptionRepository) {
    suspend operator fun invoke(
        plan: String,
        platform: String,
        storeProductId: String,
        receiptToken: String,
        amount: Double,
        currency: String,
        storeTransactionId: String,
    ): Result<Subscription> = repository.submitReceipt(
        plan = plan,
        platform = platform,
        storeProductId = storeProductId,
        receiptToken = receiptToken,
        amount = amount,
        currency = currency,
        storeTransactionId = storeTransactionId,
    )
}
